import './GeoCoder.scss';
import Component from './GeoCoder.js';
export default Component;
